import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_event/$eventSlug/missoes/')({
  beforeLoad: () => {
    throw redirect({
      to: '/missoes',
      replace: true
    })
  }
})
